import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "react-feather";
import { getApiBaseUrl } from '../../utils/apiConfig';
import PageHeader from "../../shared/page-header/PageHeader";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import CompanyDropdown from "../../shared/common-dropdown/CompanyDropdown";
import { getStorageValues } from "../../shared/CommonFunctions";
import axios from "axios";
import RoleModal from "./RoleModal";
import ModulePermissionGrid from "./ModulePermissionGrid";
import { logAuditEvent } from '../../utils/auditLogger';

function RoleSecurityMain(props) {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [getRole, setRole] = React.useState([]);
  const [alert, setAlert] = useState(null);
  const [getCompanyId, setCompanyId] = useState(0);
  const [activeIndex, setActiveIndex] = useState(null);
  const [getRoleModulePermissionList, setRoleModulePermissionList] = useState([]);
  const [actionType, setActionType] = useState();
  const [getRoleModal, setRoleModal] = React.useState([]);
  const [isSavingPermissions, setIsSavingPermissions] = useState(false);
  const permissionSaveQueueRef = useRef([]);
  const isProcessingPermissionRef = useRef(false);
  const rolePermissionRequestVersionRef = useRef(0);
  const moduleName = props.Module || 'Role Security';

  React.useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Role Security');
  }, [moduleName]);

  function openAddRoleModal() {
    setIsOpen(true);
    setActionType("Add");
    logAuditEvent(moduleName, 'Add Role Click', 'Opened add role modal');
  }
  function closeModal() {
    setIsOpen(false);
  }


  async function onSubmit(e, data) {
    const roleModel = data;
    if (roleModel) {
      if (e.target.name === "Add") {
        logAuditEvent(moduleName, 'Save Role Attempt', 'Creating new role');
        let roleDetails = {
          RoleId: null,
          RoleName: roleModel.RoleName ? roleModel.RoleName : "",
          NormalizedName: roleModel.NormalizedName ? roleModel.NormalizedName : "",
          CompanyId: getCompanyId,
          UserId: getStorageValues('userId'),
          HasAdminRights: roleModel.HasAdminRights ? roleModel.HasAdminRights : 0
        };
        if (validation(roleDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saverole",
              roleDetails
            );
            if (response.status === 200) {
              if (response.data.data[0].success === 1) {
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'Role Saved', response.data.data[0].message || 'Success');
                fetchRoleByCompanyId(getCompanyId);
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            }
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'Role Save Failed', error.message || 'Unknown error');
          }
        } else {
          CreateAlert("Please enter proper data!!", "Error", setAlert);
        }
      } if (e.target.name === "Edit") {
        logAuditEvent(moduleName, 'Save Role Attempt', `Editing role ${roleModel.RoleId}`);
        let roleDetails = {
          RoleId: roleModel.RoleId,
          RoleName: roleModel.RoleName ? roleModel.RoleName : "",
          NormalizedName: roleModel.NormalizedName ? roleModel.NormalizedName : "",
          CompanyId: getCompanyId,
          UserId: getStorageValues('userId'),
          HasAdminRights: roleModel.HasAdminRights ? roleModel.HasAdminRights : 0
        };
        if (validation(roleDetails)) {
          try {
            const response = await axios.post(
              getApiBaseUrl() + "/saverole",
              roleDetails
            );
            if (response.status === 200) {
              if (response.data.data[0].success === 1) {
                CreateAlert(response.data.data[0].message, "Success", setAlert);
                logAuditEvent(moduleName, 'Role Updated', response.data.data[0].message || 'Success');
                fetchRoleModulePermissionList(roleDetails.RoleId, getCompanyId);
                fetchRoleByCompanyId(getCompanyId);
                closeModal();
              } else {
                CreateAlert(response.data.data[0].message, "Error", setAlert);
              }
            }
          } catch (error) {
            console.log(error);
            logAuditEvent(moduleName, 'Role Update Failed', error.message || 'Unknown error');
          }
        } else {
          CreateAlert("Please enter proper data!!", "Error", setAlert);
        }
      } if (e.target.name === "Delete") {
        logAuditEvent(moduleName, 'Delete Role Attempt', `RoleId=${roleModel.RoleId}`);
        let roleDetails = {
          RoleId: roleModel.RoleId
        };
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/deleteRole", roleDetails
          );
          if (response.status === 200) {
            CreateAlert("Role deleted successfully!!", "Success", setAlert);
            logAuditEvent(moduleName, 'Role Deleted', `RoleId=${roleModel.RoleId}`);
            fetchRoleByCompanyId(getCompanyId);
            closeModal();
          }
        } catch (error) {
          console.log(error);
          logAuditEvent(moduleName, 'Role Delete Failed', error.message || 'Unknown error');
        }
      }
    }
  }
  function validation(roleDetails) {
    var validation = true;
    if (roleDetails) {
      if (roleDetails.RoleName !== null) {
        if (roleDetails.RoleName.length === 0) {
          CreateAlert("Please enter role!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter role!!", "Warning", setAlert);
        validation = false;
        return;
      }
    }
    return validation;
  }
  function handleDropdownChange(e) {
    const companyId = e.value;
    setCompanyId(companyId);
    fetchRoleByCompanyId(companyId);
    logAuditEvent(moduleName, 'Company Selected', `CompanyId=${companyId}`);
  }
  function onClickRole(e, item, index) {
    if (e) e.preventDefault();
    setActiveIndex(index);
    fetchRoleModulePermissionList(item.RoleId, item.CompanyId);
    logAuditEvent(moduleName, 'Role Selected', `RoleId=${item.RoleId}`);
  }
  function onEdit(row) {
    setRoleModal(row);
    setIsOpen(true);
    setActionType("Edit");
    logAuditEvent(moduleName, 'Edit Role Open', `RoleId=${row.RoleId}`);
  }
  const fetchRoleByCompanyId = async (companyId) => {
    try {
      const response = await axios.get(`${getApiBaseUrl()}/getrolesbycompany`, {
        params: { CompanyId: companyId }
      });

      if (response.status === 200 && response.data.data[0]?.length > 0) {
        const roles = response.data.data[0];
        const firstRole = roles[0];

        setRole(roles);
        setActiveIndex(0);
        fetchRoleModulePermissionList(firstRole.RoleId, companyId);
      } else {
        setRole([]);
        setRoleModulePermissionList([]);
      }
    } catch (error) {
      console.error("Failed to fetch roles", error);
    }
  };
  const fetchRoleModulePermissionList = async (roleId, companyId) => {
    const requestVersion = ++rolePermissionRequestVersionRef.current;
    try {
      let roleModuleDetails = {
        UserId: getStorageValues('userId'),
        RoleId: roleId,
        CompanyId: companyId,
        ApplicationId: process.env.REACT_APP_APPLICATION_ID
      };
      const response = await axios.get(getApiBaseUrl() + "/getRoleModulePermissions", {
        params: roleModuleDetails
      });
      if (response.status === 200 && requestVersion === rolePermissionRequestVersionRef.current) {
        setGroupedModules(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function setGroupedModules(flatModules) {
    const groupedModules = flatModules
      .filter(m => m.ParentmoduleId === null)
      .map(parent => ({
        groupName: parent.ModuleName,
        items: flatModules.filter(child => child.ParentmoduleId === parent.ModuleId),
        RoleId: parent.RoleId,
        ModuleId: parent.ModuleId,
        ViewModule: parent.ViewModule,
        AddModule: parent.AddModule,
        EditModule: parent.EditModule,
        DeleteModule: parent.DeleteModule
      }));
    setRoleModulePermissionList(groupedModules);
  }
  function getPermissionActionColumn(action) {
    if (action === "View") return "ViewModule";
    if (action === "Add") return "AddModule";
    if (action === "Edit") return "EditModule";
    return "DeleteModule";
  }

  function getTargetModuleIds(row) {
    if (row.ParentmoduleId == null || row.ParentmoduleId === undefined) {
      return (row.items || []).map(item => item.ModuleId);
    }
    return [row.ModuleId];
  }

  function getPermissionDetails(row, action, permissionValue, companyId) {
    const moduleIds = getTargetModuleIds(row);
    return {
      UserID: getStorageValues('userId'),
      RoleId: row.RoleId,
      ModuleId: `[${moduleIds.join(',')}]`,
      CompanyId: companyId,
      PermissionValue: permissionValue,
      Action: action
    };
  }

  function applyPermissionChangeLocally(row, action, permissionValue) {
    const columnName = getPermissionActionColumn(action);
    const targetModuleIds = getTargetModuleIds(row);
    const isParentRow = row.ParentmoduleId == null || row.ParentmoduleId === undefined;

    setRoleModulePermissionList((previousList) =>
      previousList.map((group) => {
        const shouldUpdateGroup = (isParentRow && group.ModuleId === row.ModuleId) || targetModuleIds.includes(group.ModuleId);

        const updatedItems = (group.items || []).map((item) => {
          if (!targetModuleIds.includes(item.ModuleId)) {
            return item;
          }
          return {
            ...item,
            [columnName]: permissionValue
          };
        });

        if (!shouldUpdateGroup && updatedItems === group.items) {
          return group;
        }

        return {
          ...group,
          [columnName]: shouldUpdateGroup ? permissionValue : group[columnName],
          items: updatedItems
        };
      })
    );
  }

  async function processPermissionQueue() {
    if (isProcessingPermissionRef.current) {
      return;
    }

    isProcessingPermissionRef.current = true;
    setIsSavingPermissions(true);

    try {
      while (permissionSaveQueueRef.current.length > 0) {
        const queueItem = permissionSaveQueueRef.current.shift();
        const { row, action, permissionValue, companyId, roleId } = queueItem;
        const permissionDetails = getPermissionDetails(row, action, permissionValue, companyId);

        applyPermissionChangeLocally(row, action, permissionValue);

        try {
          const response = await axios.post(
            getApiBaseUrl() + "/savemodulepermissions",
            permissionDetails
          );

          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              logAuditEvent(moduleName, 'Permission Updated', `RoleId=${roleId}, Action=${action}`);
            } else {
              CreateAlert(response.data.data[0].message, "Error", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
          logAuditEvent(moduleName, 'Permission Update Failed', error.message || 'Unknown error');
        }

        await fetchRoleModulePermissionList(roleId, companyId);
      }
    } finally {
      isProcessingPermissionRef.current = false;
      setIsSavingPermissions(false);
    }
  }

  function onPermissionToggle(e, row, action) {
    const permissionValue = e.target.checked ? 1 : 0;
    permissionSaveQueueRef.current.push({
      row,
      action,
      permissionValue,
      roleId: row.RoleId,
      companyId: getCompanyId
    });
    processPermissionQueue();
  }
  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayText=""
        displayModule={props.Module}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={false}
      />
      <RoleModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        onSubmit={onSubmit}
        selectedRow={getRoleModal}
      />
      <div className="card">
        <div className="card-body">
          <div className="col-lg-6 col-sm-6 col-12 ">
            <label className="form-label">Select Company <span style={{ color: "red" }}>*</span></label>
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-6">
                <CompanyDropdown
                  modelName="CompanyId"
                  required={true}
                  onChangeDropdown={handleDropdownChange}
                />
              </div>
              <div className="col-lg-2 col-sm-2 col-2 ps-0">
                <div className="add-icon">
                  <button
                    className="btn btn-submit ddbtnicon2"
                    onClick={openAddRoleModal}
                  ><Icons.PlusCircle size={18} className="me-2" />Add Role</button>
                </div>
              </div>
              {/* <div className="col-lg-2 col-sm-2 col-2 ps-0">
                <button className="btn btn-cancel me-2">Reset</button>
              </div> */}
            </div>
          </div>
          <div className="row transform-none">
            <div className="col-xl-12 transform-none">
              <div className="settings-wrapper d-flex transform-none">
                <div className="sidebars settings-sidebar relative-position overflow-visible box-border min-height-1" id="sidebar2">
                  <div className="static-position transform-none">
                    <div className="slimScrollDiv slim-scroll">
                      <div className="sidebar-inner slimscroll slimscroll-inner">
                        <div className="container mt-3">
                          {
                            getRole.length === 0 ? (
                              <p className="text-muted">No roles to display.</p>
                            ) : (
                              getRole.map((item, index) => (
                                <Link
                                  key={index}
                                  onClick={(e) => { onClickRole(e, item, index); }}
                                  onDoubleClick={() => onEdit(item)}
                                  name={item.RoleName}
                                  className={`dropdown-item d-flex justify-content-between align-items-center ${activeIndex === index ? 'active' : ''}`}
                                  title="Double Click To Edit"
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    {/* Role Name */}
                                    <span>{item.RoleName}</span>

                                    {/* Admin Rights Indicator */}
                                    {item.HasAdminRights === 1 && (
                                      <span
                                        className="badge bg-warning text-dark"
                                        title="Admin Rights"
                                        style={{
                                          fontSize: "0.7rem",
                                          borderRadius: "0.4rem",
                                          padding: "0.25em 0.5em"
                                        }}
                                      >
                                        Admin
                                      </span>
                                    )}
                                  </div>

                                  {/* Edit Icon */}
                                  <Icons.Edit
                                    onClick={() => onEdit(item)}
                                    size={14}
                                    className="text-muted hover:text-primary"
                                  />
                                </Link>
                              ))
                            )
                          }
                        </div>
                      </div>
                      <div className="slimScrollBar slimscroll-bar" />
                      <div className="slimScrollRail" />
                    </div>
                    <div className="resize-sensor">
                      <div className="resize-expand"><div /></div>
                      <div className="resize-shrink"><div /></div>
                    </div>
                  </div>
                </div>

                {/* Main Content */}
                <div className="settings-page-wrap">
                  <div className="security-settings">
                    <div
                      className="table-responsive no-pagination"
                      style={{
                        pointerEvents: (activeIndex !== null && getRole[activeIndex]?.HasAdminRights === 1) || isSavingPermissions ? "none" : "auto",
                        opacity: activeIndex !== null && getRole[activeIndex]?.HasAdminRights === 1 ? 0.6 : 1,
                      }}
                    >
                      <ModulePermissionGrid
                        RoleModulePermissionListData={getRoleModulePermissionList}
                        fetchRoleModulePermissionList={fetchRoleModulePermissionList}
                        onPermissionToggle={onPermissionToggle}
                        isSavingPermissions={isSavingPermissions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RoleSecurityMain;

